import Alert from 'react-s-alert';
import { I18nUtils } from '../../../i18n/I18nUtils';
import UpdateUserRequest from '../../users/ws/UpdateUserRequest';
import { AUTH_LOGIN_UPDATE } from '../../login/actions/authActions';
import UploadRequest from '../ws/UploadRequest';
import { push } from 'react-router-redux';
import { PsRoutes } from '../../shared/routing/Routes';

export const PROFILE_SET_LOADING = 'profile-set-loading';

export const updateProfile = (user = {}, imageFile = null) => (dispatch) => {
    if ( imageFile ) {
        new UploadRequest(imageFile)
            .onPreExecution(() => {
                dispatch({ type: PROFILE_SET_LOADING, payload: true });
            })
            .onSuccess(data => {
                user.image = data.data.url;
                dispatch({
                    type: AUTH_LOGIN_UPDATE,
                    payload: { image: user.image },
                });
                updateUser(user, dispatch);
            })
            .onFail(error => {
                Alert.error(error || I18nUtils.tr('TR_UPDATE_PROFILE_ERROR'));
                dispatch({ type: PROFILE_SET_LOADING, payload: false });
            })
            .execute();
    } else {
        updateUser(user, dispatch);
    }
};

function updateUser(user, dispatch) {
    new UpdateUserRequest(user.id, user)
        .onPreExecution(() => {
            dispatch({ type: PROFILE_SET_LOADING, payload: true });
        })
        .onSuccess(data => {
            Alert.success(I18nUtils.tr('TR_UPDATE_PROFILE_SUCCESS'));
            dispatch({
                type: AUTH_LOGIN_UPDATE,
                payload: user,
            });
            dispatch(push(PsRoutes.PROFILE));
        })
        .onFail(error => {
            Alert.error(error || I18nUtils.tr('TR_UPDATE_PROFILE_ERROR'));
        })
        .onPostExecution(() => {
            dispatch({ type: PROFILE_SET_LOADING, payload: false });
        })
        .execute();
}



// WEBPACK FOOTER //
// ./src/app/profile/actions/profileActions.js